import React from 'react'

import classNames from './AdvancedForm.css'
import ConfirmButtons from '../ConfirmButtons'
import DiversityPicker from './DiversityPicker'

export default function LimitForm ({ value, onChange, onCancel, setRootProperty, pristine }) {
  return (
    <div className={classNames.form}>
      <label>
        Limit
        <input
          type='number'
          value={value.limit || ''}
          onChange={e => onChange({ ...value, limit: parseInt(e.target.value) })}
          className={classNames.numberInput}
        />
      </label>
      <span className={classNames.note}>
        Limit is reapplied every time sort changes
      </span>
      <DiversityPicker
        value={value.diversity || 0}
        onChange={e => onChange({ ...value, diversity: parseFloat(e.target.value) })}
        onMouseUp={e => setRootProperty('diversity', parseFloat(e.target.value))}
        showSuggestedLimit
      />
      <label>
        Custom seed for random sort
        <input
          type='text'
          value={value.seed || ''}
          onChange={e => onChange({ ...value, seed: e.target.value })}
          className={classNames.numberInput}
        />
      </label>
      <ConfirmButtons
        onCancel={onCancel}
        confirmText='Submit'
        onConfirm={() => {
          setRootProperty('limit', value.limit || undefined)
          setRootProperty('seed', value.seed || undefined)
        }}
        confirmDisabled={pristine}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/LimitForm.js